import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Divider,
  Stack,
  Link
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ backgroundColor: '#1a1a1a', color: 'white', py: 8 }}>
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="center" mb={3}>
              <img
                src="/images/bookingbarber-logo.png"
                alt="BookingBarber"
                style={{ height: 40, marginRight: 16 }}
              />
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                BookingBarber
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 3, opacity: 0.8 }}>
              {t('footer.description')}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              {t('footer.product')}
            </Typography>
            <Stack spacing={1}>
              <Link
                component="button"
                onClick={() => navigate('/features')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.features')}
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/pricing')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.pricing')}
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/auth?mode=signup')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.freeDemo')}
              </Link>
            </Stack>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              {t('footer.company')}
            </Typography>
            <Stack spacing={1}>
              <Link
                component="button"
                onClick={() => navigate('/about')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.about')}
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/posts')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.blog')}
              </Link>
            </Stack>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              {t('footer.support')}
            </Typography>
            <Stack spacing={1}>
              <Link
                component="button"
                onClick={() => navigate('/support')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.helpCenter')}
              </Link>
              <Link
                href="mailto:support@omnivers.fr"
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 } }}
              >
                {t('footer.contact')}
              </Link>
            </Stack>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              {t('footer.legal')}
            </Typography>
            <Stack spacing={1}>
              <Link
                component="button"
                onClick={() => navigate('/privacy')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.privacy')}
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/terms')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.terms')}
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/cookies')}
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: 'left' }}
              >
                {t('footer.cookies')}
              </Link>
            </Stack>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, backgroundColor: 'rgba(255,255,255,0.1)' }} />
        
        {/* Partnership Section */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              mb: 2,
              fontWeight: 'bold',
              color: '#f5f5dc'
            }}
          >
            Nos Partenaires
          </Typography>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 4,
            flexWrap: 'wrap'
          }}>
            <Typography
              variant="body1"
              sx={{
                color: '#ccc',
                fontWeight: 500,
                '&:hover': { color: '#f5f5dc' },
                cursor: 'pointer'
              }}
            >
              BarberOne
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#ccc',
                fontWeight: 500,
                '&:hover': { color: '#f5f5dc' },
                cursor: 'pointer'
              }}
            >
              Destock coiff
            </Typography>
          </Box>
        </Box>
        
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              {t('footer.copyright')}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box textAlign={{ xs: 'left', md: 'right' }}>
              <Button
                variant="contained"
                onClick={() => navigate('/auth?mode=signup')}
                sx={{
                  backgroundColor: '#f5f5dc',
                  color: 'black',
                  fontWeight: 'bold',
                  px: 3,
                  py: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#e8e8c8'
                  }
                }}
              >
                Commencer gratuitement
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;